import script from "./ProductBranchManageModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductBranchManageModal.vue?vue&type=script&setup=true&lang=js"

import "./ProductBranchManageModal.vue?vue&type=style&index=0&id=ac5bb7c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac5bb7c4"]])

export default __exports__